import { createFileRoute } from "@tanstack/react-router";
import BuilderPortalLayout from "lib/components/builders/BuilderPortalLayout";
import IntegrationConnectorAgent from "lib/components/integrations/IntegrationConnectorAgent";
import IntegrationJobs from "lib/components/integrations/IntegrationJobs";
import IntegrationSetup from "lib/components/integrations/IntegrationSetup";
import IntegrationConnectorMappings from "lib/components/integrations/mappings/IntegrationConnectorMappings";
import { PreviewImportContextProvider } from "lib/components/integrations/preview/usePreviewImportModal";
import { useUserContext } from "lib/state/UserContextProvider";
import useTabbedMenu from "ui/hooks/useTabbedMenu";
import withAuthentication from "../../../../components/withAuthentication";

export type IntegrationsPageSection = "setup" | "jobs" | "mappings" | "connector_agent";

function IntegrationsPage() {
  const { enabledFeatures } = useUserContext();
  const visibleTabs: IntegrationsPageSection[] = [
    "setup",
    "jobs",
    ...(enabledFeatures.connectorMappings ? (["mappings"] as const) : []),
    ...(enabledFeatures.integrationAgent ? (["connector_agent"] as const) : []),
  ];
  const { tab, menuItems } = useTabbedMenu<IntegrationsPageSection>(visibleTabs);

  return (
    <PreviewImportContextProvider>
      <BuilderPortalLayout header="ERP Integrations" pageTitle="ERP Integrations" menuItems={menuItems}>
        <div className="builder-portal-layout-content">
          {tab === "setup" && <IntegrationSetup />}
          {tab === "mappings" && <IntegrationConnectorMappings />}
          {tab === "jobs" && <IntegrationJobs />}
          {tab === "connector_agent" && <IntegrationConnectorAgent />}
        </div>
      </BuilderPortalLayout>
    </PreviewImportContextProvider>
  );
}

export const Route = createFileRoute("/builders/$builder_id/integrations/")({
  component: withAuthentication(IntegrationsPage, { permissions: ["VIEW_INTEGRATIONS"], features: ["integrations"] }),
});
